import { useState } from 'react'
import { Collapse } from 'react-collapse'
import { useRouter } from 'next/router';

export default function AccordianFaq({ faqData }) {
  const router = useRouter();
  const { locale } = router;
  const [openIndex, setOpenIndex] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  return (
    <>
    {faqData &&
      faqData.map((item, index) => (
        <div key={index} className={`border-b-[1px] border-bordercolor py-2 mb-2 ${!showAll && index >= 5 ? 'hidden' : ''}`}>
          <div className='bg-white flex justify-between items-center cursor-pointer' onClick={() => toggle(index)}>
            <p className='text-lg text-secondary sm:text-base font-regular'>{item.Q ? item.Q : item.question}</p>
            <div>
              {openIndex === index ? (
                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                  <path fill="none" d="M0 0h24v24H0z"/><path d="M5 11h14v2H5z"/>
                </svg>
              ) : (
                <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                  <path fill="none" d="M0 0h24v24H0z"/><path d="M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z"/>
                </svg>
              )}
            </div>
          </div>
          <Collapse isOpened={openIndex === index}>
            <div className='bg-white text-base sm:text-sm text-secondary mt-1'>
              {item.A}
              {item.answers && <div className='mt-3' dangerouslySetInnerHTML={{__html:item.answers}}/>}

              {item.list && (
                <ul className='pl-[20px] mt-1'>
                  {item.list.map((li, i) => (
                    <li key={i} className='list-disc mb-1' dangerouslySetInnerHTML={{__html:li}}/>
                  ))}
                </ul>
              )}
              {item.A2 && <p className='mt-3'> {item.A2}</p>}
              {item.list2 && (
                <ul className='pl-[20px] mt-1'>
                  {item.list2.map((li, i) => (
                    <li key={i} className='list-disc mb-1' dangerouslySetInnerHTML={{__html:li}} />
                  ))}
                </ul>
              )}
            </div>
          </Collapse>
        </div>
      ))}
       {faqData.length > 5 && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="mt-3 flex items-center text-base font-medium text-atom_BondiBlue"
        >
          <span className='inline-block'>
            {showAll ? (locale === 'es-mx' ? 'Mostrar menos' : 'Show Less' ):(locale === 'es-mx' ? 'Mostrar más':'Show More')}
          </span>
        </button>
      )}
    </>
  );
}
